import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchAlarmSummary } from '../thunk/AlarmsThunk'; 

const initialData: any = [];

const AlarmSummarySlice: Slice<any, {}, "AlarmSummarySlice"> = createSlice({
    name: "AlarmSummarySlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchAlarmSummary.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchAlarmSummary.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchAlarmSummary.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default AlarmSummarySlice;